import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiAssignmentsResponseModel } from '@/types'

export const getKpiAssignments = async (
  branchName?: string
): Promise<KpiAssignmentsResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/kpi/assignments`, {
      params: {
        ...(branchName && { branch_name: branchName }),
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
